import { AllowAdvertisementStatus, ShareBirthdayStatus } from '@core/enums';
import { Expose } from 'class-transformer';

export class SharingInfoEntity {
  @Expose({ name: 'share_birthday' })
  shareBirthday: ShareBirthdayStatus;

  @Expose({ name: 'allowAdvertis' })
  allowAdvertisement: AllowAdvertisementStatus;

  get shareBirthdayBool(): boolean {
    return this.shareBirthday === ShareBirthdayStatus.Yes;
  }

  get allowAdvertisementBool(): boolean {
    return this.allowAdvertisement === AllowAdvertisementStatus.Yes;
  }
}
